export const borderWidths = {
  s: 1,
  m: 2,
  l: 4,
};
